import image1 from "../assests/Images/hero/image1.png";
import image2 from "../assests/Images/hero/image2.png";
import image3 from "../assests/Images/hero/image3.png";
import image4 from "../assests/Images/hero/image4.png";
import image5 from "../assests/Images/hero/image5.png";
import image6 from "../assests/Images/hero/image6.png";
import placed from "../assests/Images/hero/placed.png";
import "../styles/hero.css";
import { useEffect } from "react";
import AOS from "aos";
import "aos/dist/aos.css";

function Hero ({anim}){

    useEffect(() => {
        if (anim!=="true") {
          AOS.init({
            duration: 1000, // Optional: you can customize the animation duration or other settings
            once: true, // Optional: ensures animations only trigger once
            startEvent: 'DOMContentLoaded', // Optional: triggers AOS on specific event
            // offset: 100,
          });
        }
      }, [anim]);

      
      const getAosData = (anima, delay) => {
        return anim==="true"? null : { "data-aos": anima, "data-aos-delay": delay };
      };
    
    return (
        <div className="hero-sec">
            <div className="hero-section-container">
                <h1 {...getAosData("fade-up",200)}  className="hero-text" >
                Anchored in <span className="hero-text2">Excellence:</span> Supporting Your Voyage in the <span className="hero-text2">Marine
                Industry</span>.
                </h1>
                <a  {...getAosData("fade-up",300)}  href="#aboutus" className="our-hero-button" >
                Explore more
                </a>
                <div className="hero-section-img2">
                    <img  {...getAosData("fade-right",500)} src={placed} alt="" />
                    <h1  {...getAosData("fade-right",500)} >Students Placed</h1>
                </div>   
            </div>
            <div className="hero-section-img">
                <div className="hero-section-img-container1">
                <img {...getAosData("fade-left",0)} className="hero3b" src={image1} alt="" onLoad={() => console.log('Image 1 loaded')} />
                <img {...getAosData("fade-up",200)} className="hero4b" src={image2} alt="" />
                </div>
                <div className="hero-section-img-container1">
                    <img {...getAosData("fade-down",400)} className="hero4a" src={image3} alt="" />
                    <img {...getAosData("fade-up",600)} className="hero3a" src={image4} alt="" />
                </div>
                <div className="hero-section-img-container1">
                    <img {...getAosData("fade-left",800)} className="hero3" src={image5} alt="" />
                    <img {...getAosData("fade-up",1000)} className="hero4" src={image6} alt="" />
                </div>
                
            </div>     
            
        </div>
    )
}

export default Hero;